export default "__VITE_ASSET__DikI0wom__"